import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function () {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/cannot-login" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="I cannot login/forgotten password" />
      <p>
        You can log in using either your <strong>Username</strong> or your <strong>Email Address</strong>.
        If you forgot your password please follow <Link to="/shop/reset-password">Reset Password</Link>{' '}
        to get a new one. If you think you might not have received the <strong>Reset Password email</strong>, please
        check your <strong>spam</strong> or junk folder.
      </p>
      <p>
        Please remember that both, Username and Password are <strong>Case Sensitive</strong>.
      </p>
      <p>
        Also, when logging in, we recommend checking the <strong>&quot;Keep me signed in&quot;</strong> so that you will not have to
        re-login very often. As well, most browsers have a feature of saving passwords - this would make your logging
        into services more convenient.
      </p>

      <HelpContactUs subject={5} />
    </div>
  );
}
